module.exports = __webpack_public_path__ + "img/hr-tree-02-d-trunk.93412ae3.png";